


















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
moment.locale('es-MX')

@Component
export default class DialogViewVenta extends Vue {
  @Prop({ type: Object })
  private info!: object

  private name: string = 'DialogViewVenta'
  private show: boolean = false
  private showBoletos: boolean = false

  private mModel: object = {
    amountPay: 0,
    amountClient: 0,
    amountCashBack: 0,
    amountCorteCaja: 0,
    paymentMethod: '',
    isCancel: false,
    idOrder: '',
    createdAt: '',
    boleto: [],
    reference: null,
    taquilla: {
      name: '',
      user: {
        name: ''
      }
    }
  }

  private bModel: object = {
    amountPay: 0,
    amountClient: 0,
    amountCashBack: 0,
    amountCorteCaja: 0,
    paymentMethod: '',
    idOrder: '',
    createdAt: '',
    boleto: [],
    isCancel: false,
    reference: null,
    taquilla: {
      name: '',
      user: {
        name: ''
      }
    }
  }

  private headers: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Folio', value: 'folio' },
    { text: 'Costo', value: 'cost' }
  ]

  private beforeMount () {
    console.log('beforeMount :: DialogViewVenta')
    if ((typeof this.info === 'object')  && (this.info !== null)) {
      this.mModel = this.info
    }
  }

  @Watch('info')
  private watchInfo (v: any) {
    console.log('watchInfo :: ', v)
    if ((typeof v === 'object') && (v !== null)) {
      this.mModel = Object.assign({}, v)
      this.show = true
    }
  }

  @Watch('show')
  private watchShow (v: boolean) {
    if (!v) {
      this.mModel = Object.assign({}, this.bModel)
    }
  }
}
